/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteImport } from './routes/_app'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as SandboxEnterRouteImport } from './routes/sandbox-enter'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as AppAuditLogsRouteImport } from './routes/_app/audit-logs'
import { Route as AppHelpRouteImport } from './routes/_app/help'
import { Route as AuthForgotPasswordRouteImport } from './routes/_auth/forgot-password'
import { Route as AuthResetPasswordRouteImport } from './routes/_auth/reset-password'
import { Route as AuthSignUpRouteImport } from './routes/_auth/sign-up'
import { Route as AuthSupportSignInRouteImport } from './routes/_auth/support-sign-in'
import { Route as CTokenRouteImport } from './routes/c/$token'
import { Route as AppAccountingCashbookRouteImport } from './routes/_app/accounting/cashbook'
import { Route as AppAccountingExpensesRouteImport } from './routes/_app/accounting/expenses'
import { Route as AppCatalogSetupRouteImport } from './routes/_app/catalog/setup'
import { Route as AppCustomersIndexRouteImport } from './routes/_app/customers/index'
import { Route as AppCustomersIdRouteImport } from './routes/_app/customers/$id'
import { Route as AppCustomersOnlineAccountsRouteImport } from './routes/_app/customers/online-accounts'
import { Route as AppInventoryHistoryRouteImport } from './routes/_app/inventory/history'
import { Route as AppInventoryStockRouteImport } from './routes/_app/inventory/stock'
import { Route as AppInvitationsTokenRouteImport } from './routes/_app/invitations/$token'
import { Route as AppMarketingCouponsRouteImport } from './routes/_app/marketing/coupons'
import { Route as AppOrdersIndexRouteImport } from './routes/_app/orders/index'
import { Route as AppOrdersIdRouteImport } from './routes/_app/orders/$id'
import { Route as AppOrdersCallsRouteImport } from './routes/_app/orders/calls'
import { Route as AppOrdersNewRouteImport } from './routes/_app/orders/new'
import { Route as AppOrdersReturnsRouteImport } from './routes/_app/orders/returns'
import { Route as AppOrdersRtoRouteImport } from './routes/_app/orders/rto'
import { Route as AppPaymentsIndexRouteImport } from './routes/_app/payments/index'
import { Route as AppPaymentsAccountsRouteImport } from './routes/_app/payments/accounts'
import { Route as AppPosDevicesRouteImport } from './routes/_app/pos/devices'
import { Route as AppPosReviewsRouteImport } from './routes/_app/pos/reviews'
import { Route as AppPurchasingPayablesRouteImport } from './routes/_app/purchasing/payables'
import { Route as AppReportsIndexRouteImport } from './routes/_app/reports/index'
import { Route as AppSettingsAppearanceRouteImport } from './routes/_app/settings/appearance'
import { Route as AppSettingsBillingRouteImport } from './routes/_app/settings/billing'
import { Route as AppSettingsBusinessRouteImport } from './routes/_app/settings/business'
import { Route as AppSettingsCouriersRouteImport } from './routes/_app/settings/couriers'
import { Route as AppSettingsDataRouteImport } from './routes/_app/settings/data'
import { Route as AppSettingsDeliveryZonesRouteImport } from './routes/_app/settings/delivery-zones'
import { Route as AppSettingsFraudRouteImport } from './routes/_app/settings/fraud'
import { Route as AppSettingsOnlineStoreRouteImport } from './routes/_app/settings/online-store'
import { Route as AppSettingsSecurityRouteImport } from './routes/_app/settings/security'
import { Route as AppSettingsSessionsRouteImport } from './routes/_app/settings/sessions'
import { Route as AppSettingsStaffRouteImport } from './routes/_app/settings/staff'
import { Route as AppSettingsSupportRouteImport } from './routes/_app/settings/support'
import { Route as AppSettingsThemesRouteImport } from './routes/_app/settings/themes'
import { Route as AuthSignInIndexRouteImport } from './routes/_auth/sign-in/index'
import { Route as AuthSignInOtpRouteImport } from './routes/_auth/sign-in/otp'
import { Route as AuthSignInTotpRouteImport } from './routes/_auth/sign-in/totp'
import { Route as AppCatalogImportIndexRouteImport } from './routes/_app/catalog/import/index'
import { Route as AppCatalogImportIdRouteImport } from './routes/_app/catalog/import/$id'
import { Route as AppCatalogProductsIndexRouteImport } from './routes/_app/catalog/products/index'
import { Route as AppCatalogProductsIdRouteImport } from './routes/_app/catalog/products/$id'
import { Route as AppCatalogProductsNewRouteImport } from './routes/_app/catalog/products/new'
import { Route as AppInventoryAdjustmentsIndexRouteImport } from './routes/_app/inventory/adjustments/index'
import { Route as AppInventoryAdjustmentsIdRouteImport } from './routes/_app/inventory/adjustments/$id'
import { Route as AppInventoryAdjustmentsNewRouteImport } from './routes/_app/inventory/adjustments/new'
import { Route as AppInventoryCountsIndexRouteImport } from './routes/_app/inventory/counts/index'
import { Route as AppInventoryCountsIdRouteImport } from './routes/_app/inventory/counts/$id'
import { Route as AppInventoryCountsNewRouteImport } from './routes/_app/inventory/counts/new'
import { Route as AppInventoryTransfersIndexRouteImport } from './routes/_app/inventory/transfers/index'
import { Route as AppInventoryTransfersIdRouteImport } from './routes/_app/inventory/transfers/$id'
import { Route as AppInventoryTransfersNewRouteImport } from './routes/_app/inventory/transfers/new'
import { Route as AppOrdersIdEditRouteImport } from './routes/_app/orders/$id_.edit'
import { Route as AppOrdersIdExchangeRouteImport } from './routes/_app/orders/$id_.exchange'
import { Route as AppOrdersIdReturnRouteImport } from './routes/_app/orders/$id_.return'
import { Route as AppPaymentsCodIndexRouteImport } from './routes/_app/payments/cod/index'
import { Route as AppPaymentsCodIdRouteImport } from './routes/_app/payments/cod/$id'
import { Route as AppPurchasingOrdersIndexRouteImport } from './routes/_app/purchasing/orders/index'
import { Route as AppPurchasingOrdersIdRouteImport } from './routes/_app/purchasing/orders/$id'
import { Route as AppPurchasingOrdersNewRouteImport } from './routes/_app/purchasing/orders/new'
import { Route as AppPurchasingReceiptsIndexRouteImport } from './routes/_app/purchasing/receipts/index'
import { Route as AppPurchasingReceiptsIdRouteImport } from './routes/_app/purchasing/receipts/$id'
import { Route as AppPurchasingReceiptsNewRouteImport } from './routes/_app/purchasing/receipts/new'
import { Route as AppPurchasingReturnsIndexRouteImport } from './routes/_app/purchasing/returns/index'
import { Route as AppPurchasingReturnsIdRouteImport } from './routes/_app/purchasing/returns/$id'
import { Route as AppPurchasingReturnsNewRouteImport } from './routes/_app/purchasing/returns/new'
import { Route as AppPurchasingSuppliersIndexRouteImport } from './routes/_app/purchasing/suppliers/index'
import { Route as AppPurchasingSuppliersIdRouteImport } from './routes/_app/purchasing/suppliers/$id'
import { Route as AppReportsGroupReportRouteImport } from './routes/_app/reports/$group.$report'
import { Route as AppReportsExportsIdRouteImport } from './routes/_app/reports/exports.$id'
import { Route as AppSettingsLocationsIndexRouteImport } from './routes/_app/settings/locations/index'
import { Route as AppSettingsLocationsIdRouteImport } from './routes/_app/settings/locations/$id'
import { Route as AppSettingsPagesIndexRouteImport } from './routes/_app/settings/pages/index'
import { Route as AppSettingsPagesIdRouteImport } from './routes/_app/settings/pages/$id'

const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const SandboxEnterRoute = SandboxEnterRouteImport.update({
  id: '/sandbox-enter',
  path: '/sandbox-enter',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AppAuditLogsRoute = AppAuditLogsRouteImport.update({
  id: '/audit-logs',
  path: '/audit-logs',
  getParentRoute: () => AppRoute,
} as any)
const AppHelpRoute = AppHelpRouteImport.update({
  id: '/help',
  path: '/help',
  getParentRoute: () => AppRoute,
} as any)
const AuthForgotPasswordRoute = AuthForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => AuthRoute,
} as any)
const AuthResetPasswordRoute = AuthResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSignUpRoute = AuthSignUpRouteImport.update({
  id: '/sign-up',
  path: '/sign-up',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSupportSignInRoute = AuthSupportSignInRouteImport.update({
  id: '/support-sign-in',
  path: '/support-sign-in',
  getParentRoute: () => AuthRoute,
} as any)
const CTokenRoute = CTokenRouteImport.update({
  id: '/c/$token',
  path: '/c/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const AppAccountingCashbookRoute = AppAccountingCashbookRouteImport.update({
  id: '/accounting/cashbook',
  path: '/accounting/cashbook',
  getParentRoute: () => AppRoute,
} as any)
const AppAccountingExpensesRoute = AppAccountingExpensesRouteImport.update({
  id: '/accounting/expenses',
  path: '/accounting/expenses',
  getParentRoute: () => AppRoute,
} as any)
const AppCatalogSetupRoute = AppCatalogSetupRouteImport.update({
  id: '/catalog/setup',
  path: '/catalog/setup',
  getParentRoute: () => AppRoute,
} as any)
const AppCustomersIndexRoute = AppCustomersIndexRouteImport.update({
  id: '/customers/',
  path: '/customers/',
  getParentRoute: () => AppRoute,
} as any)
const AppCustomersIdRoute = AppCustomersIdRouteImport.update({
  id: '/customers/$id',
  path: '/customers/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppCustomersOnlineAccountsRoute =
  AppCustomersOnlineAccountsRouteImport.update({
    id: '/customers/online-accounts',
    path: '/customers/online-accounts',
    getParentRoute: () => AppRoute,
  } as any)
const AppInventoryHistoryRoute = AppInventoryHistoryRouteImport.update({
  id: '/inventory/history',
  path: '/inventory/history',
  getParentRoute: () => AppRoute,
} as any)
const AppInventoryStockRoute = AppInventoryStockRouteImport.update({
  id: '/inventory/stock',
  path: '/inventory/stock',
  getParentRoute: () => AppRoute,
} as any)
const AppInvitationsTokenRoute = AppInvitationsTokenRouteImport.update({
  id: '/invitations/$token',
  path: '/invitations/$token',
  getParentRoute: () => AppRoute,
} as any)
const AppMarketingCouponsRoute = AppMarketingCouponsRouteImport.update({
  id: '/marketing/coupons',
  path: '/marketing/coupons',
  getParentRoute: () => AppRoute,
} as any)
const AppOrdersIndexRoute = AppOrdersIndexRouteImport.update({
  id: '/orders/',
  path: '/orders/',
  getParentRoute: () => AppRoute,
} as any)
const AppOrdersIdRoute = AppOrdersIdRouteImport.update({
  id: '/orders/$id',
  path: '/orders/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppOrdersCallsRoute = AppOrdersCallsRouteImport.update({
  id: '/orders/calls',
  path: '/orders/calls',
  getParentRoute: () => AppRoute,
} as any)
const AppOrdersNewRoute = AppOrdersNewRouteImport.update({
  id: '/orders/new',
  path: '/orders/new',
  getParentRoute: () => AppRoute,
} as any)
const AppOrdersReturnsRoute = AppOrdersReturnsRouteImport.update({
  id: '/orders/returns',
  path: '/orders/returns',
  getParentRoute: () => AppRoute,
} as any)
const AppOrdersRtoRoute = AppOrdersRtoRouteImport.update({
  id: '/orders/rto',
  path: '/orders/rto',
  getParentRoute: () => AppRoute,
} as any)
const AppPaymentsIndexRoute = AppPaymentsIndexRouteImport.update({
  id: '/payments/',
  path: '/payments/',
  getParentRoute: () => AppRoute,
} as any)
const AppPaymentsAccountsRoute = AppPaymentsAccountsRouteImport.update({
  id: '/payments/accounts',
  path: '/payments/accounts',
  getParentRoute: () => AppRoute,
} as any)
const AppPosDevicesRoute = AppPosDevicesRouteImport.update({
  id: '/pos/devices',
  path: '/pos/devices',
  getParentRoute: () => AppRoute,
} as any)
const AppPosReviewsRoute = AppPosReviewsRouteImport.update({
  id: '/pos/reviews',
  path: '/pos/reviews',
  getParentRoute: () => AppRoute,
} as any)
const AppPurchasingPayablesRoute = AppPurchasingPayablesRouteImport.update({
  id: '/purchasing/payables',
  path: '/purchasing/payables',
  getParentRoute: () => AppRoute,
} as any)
const AppReportsIndexRoute = AppReportsIndexRouteImport.update({
  id: '/reports/',
  path: '/reports/',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsAppearanceRoute = AppSettingsAppearanceRouteImport.update({
  id: '/settings/appearance',
  path: '/settings/appearance',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsBillingRoute = AppSettingsBillingRouteImport.update({
  id: '/settings/billing',
  path: '/settings/billing',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsBusinessRoute = AppSettingsBusinessRouteImport.update({
  id: '/settings/business',
  path: '/settings/business',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsCouriersRoute = AppSettingsCouriersRouteImport.update({
  id: '/settings/couriers',
  path: '/settings/couriers',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsDataRoute = AppSettingsDataRouteImport.update({
  id: '/settings/data',
  path: '/settings/data',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsDeliveryZonesRoute =
  AppSettingsDeliveryZonesRouteImport.update({
    id: '/settings/delivery-zones',
    path: '/settings/delivery-zones',
    getParentRoute: () => AppRoute,
  } as any)
const AppSettingsFraudRoute = AppSettingsFraudRouteImport.update({
  id: '/settings/fraud',
  path: '/settings/fraud',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsOnlineStoreRoute = AppSettingsOnlineStoreRouteImport.update({
  id: '/settings/online-store',
  path: '/settings/online-store',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsSecurityRoute = AppSettingsSecurityRouteImport.update({
  id: '/settings/security',
  path: '/settings/security',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsSessionsRoute = AppSettingsSessionsRouteImport.update({
  id: '/settings/sessions',
  path: '/settings/sessions',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsStaffRoute = AppSettingsStaffRouteImport.update({
  id: '/settings/staff',
  path: '/settings/staff',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsSupportRoute = AppSettingsSupportRouteImport.update({
  id: '/settings/support',
  path: '/settings/support',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsThemesRoute = AppSettingsThemesRouteImport.update({
  id: '/settings/themes',
  path: '/settings/themes',
  getParentRoute: () => AppRoute,
} as any)
const AuthSignInIndexRoute = AuthSignInIndexRouteImport.update({
  id: '/sign-in/',
  path: '/sign-in/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSignInOtpRoute = AuthSignInOtpRouteImport.update({
  id: '/sign-in/otp',
  path: '/sign-in/otp',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSignInTotpRoute = AuthSignInTotpRouteImport.update({
  id: '/sign-in/totp',
  path: '/sign-in/totp',
  getParentRoute: () => AuthRoute,
} as any)
const AppCatalogImportIndexRoute = AppCatalogImportIndexRouteImport.update({
  id: '/catalog/import/',
  path: '/catalog/import/',
  getParentRoute: () => AppRoute,
} as any)
const AppCatalogImportIdRoute = AppCatalogImportIdRouteImport.update({
  id: '/catalog/import/$id',
  path: '/catalog/import/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppCatalogProductsIndexRoute = AppCatalogProductsIndexRouteImport.update({
  id: '/catalog/products/',
  path: '/catalog/products/',
  getParentRoute: () => AppRoute,
} as any)
const AppCatalogProductsIdRoute = AppCatalogProductsIdRouteImport.update({
  id: '/catalog/products/$id',
  path: '/catalog/products/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppCatalogProductsNewRoute = AppCatalogProductsNewRouteImport.update({
  id: '/catalog/products/new',
  path: '/catalog/products/new',
  getParentRoute: () => AppRoute,
} as any)
const AppInventoryAdjustmentsIndexRoute =
  AppInventoryAdjustmentsIndexRouteImport.update({
    id: '/inventory/adjustments/',
    path: '/inventory/adjustments/',
    getParentRoute: () => AppRoute,
  } as any)
const AppInventoryAdjustmentsIdRoute =
  AppInventoryAdjustmentsIdRouteImport.update({
    id: '/inventory/adjustments/$id',
    path: '/inventory/adjustments/$id',
    getParentRoute: () => AppRoute,
  } as any)
const AppInventoryAdjustmentsNewRoute =
  AppInventoryAdjustmentsNewRouteImport.update({
    id: '/inventory/adjustments/new',
    path: '/inventory/adjustments/new',
    getParentRoute: () => AppRoute,
  } as any)
const AppInventoryCountsIndexRoute = AppInventoryCountsIndexRouteImport.update({
  id: '/inventory/counts/',
  path: '/inventory/counts/',
  getParentRoute: () => AppRoute,
} as any)
const AppInventoryCountsIdRoute = AppInventoryCountsIdRouteImport.update({
  id: '/inventory/counts/$id',
  path: '/inventory/counts/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppInventoryCountsNewRoute = AppInventoryCountsNewRouteImport.update({
  id: '/inventory/counts/new',
  path: '/inventory/counts/new',
  getParentRoute: () => AppRoute,
} as any)
const AppInventoryTransfersIndexRoute =
  AppInventoryTransfersIndexRouteImport.update({
    id: '/inventory/transfers/',
    path: '/inventory/transfers/',
    getParentRoute: () => AppRoute,
  } as any)
const AppInventoryTransfersIdRoute = AppInventoryTransfersIdRouteImport.update({
  id: '/inventory/transfers/$id',
  path: '/inventory/transfers/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppInventoryTransfersNewRoute =
  AppInventoryTransfersNewRouteImport.update({
    id: '/inventory/transfers/new',
    path: '/inventory/transfers/new',
    getParentRoute: () => AppRoute,
  } as any)
const AppOrdersIdEditRoute = AppOrdersIdEditRouteImport.update({
  id: '/orders/$id_/edit',
  path: '/orders/$id/edit',
  getParentRoute: () => AppRoute,
} as any)
const AppOrdersIdExchangeRoute = AppOrdersIdExchangeRouteImport.update({
  id: '/orders/$id_/exchange',
  path: '/orders/$id/exchange',
  getParentRoute: () => AppRoute,
} as any)
const AppOrdersIdReturnRoute = AppOrdersIdReturnRouteImport.update({
  id: '/orders/$id_/return',
  path: '/orders/$id/return',
  getParentRoute: () => AppRoute,
} as any)
const AppPaymentsCodIndexRoute = AppPaymentsCodIndexRouteImport.update({
  id: '/payments/cod/',
  path: '/payments/cod/',
  getParentRoute: () => AppRoute,
} as any)
const AppPaymentsCodIdRoute = AppPaymentsCodIdRouteImport.update({
  id: '/payments/cod/$id',
  path: '/payments/cod/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppPurchasingOrdersIndexRoute =
  AppPurchasingOrdersIndexRouteImport.update({
    id: '/purchasing/orders/',
    path: '/purchasing/orders/',
    getParentRoute: () => AppRoute,
  } as any)
const AppPurchasingOrdersIdRoute = AppPurchasingOrdersIdRouteImport.update({
  id: '/purchasing/orders/$id',
  path: '/purchasing/orders/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppPurchasingOrdersNewRoute = AppPurchasingOrdersNewRouteImport.update({
  id: '/purchasing/orders/new',
  path: '/purchasing/orders/new',
  getParentRoute: () => AppRoute,
} as any)
const AppPurchasingReceiptsIndexRoute =
  AppPurchasingReceiptsIndexRouteImport.update({
    id: '/purchasing/receipts/',
    path: '/purchasing/receipts/',
    getParentRoute: () => AppRoute,
  } as any)
const AppPurchasingReceiptsIdRoute = AppPurchasingReceiptsIdRouteImport.update({
  id: '/purchasing/receipts/$id',
  path: '/purchasing/receipts/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppPurchasingReceiptsNewRoute =
  AppPurchasingReceiptsNewRouteImport.update({
    id: '/purchasing/receipts/new',
    path: '/purchasing/receipts/new',
    getParentRoute: () => AppRoute,
  } as any)
const AppPurchasingReturnsIndexRoute =
  AppPurchasingReturnsIndexRouteImport.update({
    id: '/purchasing/returns/',
    path: '/purchasing/returns/',
    getParentRoute: () => AppRoute,
  } as any)
const AppPurchasingReturnsIdRoute = AppPurchasingReturnsIdRouteImport.update({
  id: '/purchasing/returns/$id',
  path: '/purchasing/returns/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppPurchasingReturnsNewRoute = AppPurchasingReturnsNewRouteImport.update({
  id: '/purchasing/returns/new',
  path: '/purchasing/returns/new',
  getParentRoute: () => AppRoute,
} as any)
const AppPurchasingSuppliersIndexRoute =
  AppPurchasingSuppliersIndexRouteImport.update({
    id: '/purchasing/suppliers/',
    path: '/purchasing/suppliers/',
    getParentRoute: () => AppRoute,
  } as any)
const AppPurchasingSuppliersIdRoute =
  AppPurchasingSuppliersIdRouteImport.update({
    id: '/purchasing/suppliers/$id',
    path: '/purchasing/suppliers/$id',
    getParentRoute: () => AppRoute,
  } as any)
const AppReportsGroupReportRoute = AppReportsGroupReportRouteImport.update({
  id: '/reports/$group/$report',
  path: '/reports/$group/$report',
  getParentRoute: () => AppRoute,
} as any)
const AppReportsExportsIdRoute = AppReportsExportsIdRouteImport.update({
  id: '/reports/exports/$id',
  path: '/reports/exports/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsLocationsIndexRoute =
  AppSettingsLocationsIndexRouteImport.update({
    id: '/settings/locations/',
    path: '/settings/locations/',
    getParentRoute: () => AppRoute,
  } as any)
const AppSettingsLocationsIdRoute = AppSettingsLocationsIdRouteImport.update({
  id: '/settings/locations/$id',
  path: '/settings/locations/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsPagesIndexRoute = AppSettingsPagesIndexRouteImport.update({
  id: '/settings/pages/',
  path: '/settings/pages/',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsPagesIdRoute = AppSettingsPagesIdRouteImport.update({
  id: '/settings/pages/$id',
  path: '/settings/pages/$id',
  getParentRoute: () => AppRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/sandbox-enter': typeof SandboxEnterRoute
  '/audit-logs': typeof AppAuditLogsRoute
  '/help': typeof AppHelpRoute
  '/forgot-password': typeof AuthForgotPasswordRoute
  '/reset-password': typeof AuthResetPasswordRoute
  '/sign-up': typeof AuthSignUpRoute
  '/support-sign-in': typeof AuthSupportSignInRoute
  '/c/$token': typeof CTokenRoute
  '/accounting/cashbook': typeof AppAccountingCashbookRoute
  '/accounting/expenses': typeof AppAccountingExpensesRoute
  '/catalog/setup': typeof AppCatalogSetupRoute
  '/customers/$id': typeof AppCustomersIdRoute
  '/customers/online-accounts': typeof AppCustomersOnlineAccountsRoute
  '/inventory/history': typeof AppInventoryHistoryRoute
  '/inventory/stock': typeof AppInventoryStockRoute
  '/invitations/$token': typeof AppInvitationsTokenRoute
  '/marketing/coupons': typeof AppMarketingCouponsRoute
  '/orders/$id': typeof AppOrdersIdRoute
  '/orders/calls': typeof AppOrdersCallsRoute
  '/orders/new': typeof AppOrdersNewRoute
  '/orders/returns': typeof AppOrdersReturnsRoute
  '/orders/rto': typeof AppOrdersRtoRoute
  '/payments/accounts': typeof AppPaymentsAccountsRoute
  '/pos/devices': typeof AppPosDevicesRoute
  '/pos/reviews': typeof AppPosReviewsRoute
  '/purchasing/payables': typeof AppPurchasingPayablesRoute
  '/settings/appearance': typeof AppSettingsAppearanceRoute
  '/settings/billing': typeof AppSettingsBillingRoute
  '/settings/business': typeof AppSettingsBusinessRoute
  '/settings/couriers': typeof AppSettingsCouriersRoute
  '/settings/data': typeof AppSettingsDataRoute
  '/settings/delivery-zones': typeof AppSettingsDeliveryZonesRoute
  '/settings/fraud': typeof AppSettingsFraudRoute
  '/settings/online-store': typeof AppSettingsOnlineStoreRoute
  '/settings/security': typeof AppSettingsSecurityRoute
  '/settings/sessions': typeof AppSettingsSessionsRoute
  '/settings/staff': typeof AppSettingsStaffRoute
  '/settings/support': typeof AppSettingsSupportRoute
  '/settings/themes': typeof AppSettingsThemesRoute
  '/sign-in/otp': typeof AuthSignInOtpRoute
  '/sign-in/totp': typeof AuthSignInTotpRoute
  '/customers/': typeof AppCustomersIndexRoute
  '/orders/': typeof AppOrdersIndexRoute
  '/payments/': typeof AppPaymentsIndexRoute
  '/reports/': typeof AppReportsIndexRoute
  '/sign-in/': typeof AuthSignInIndexRoute
  '/catalog/import/$id': typeof AppCatalogImportIdRoute
  '/catalog/products/$id': typeof AppCatalogProductsIdRoute
  '/catalog/products/new': typeof AppCatalogProductsNewRoute
  '/inventory/adjustments/$id': typeof AppInventoryAdjustmentsIdRoute
  '/inventory/adjustments/new': typeof AppInventoryAdjustmentsNewRoute
  '/inventory/counts/$id': typeof AppInventoryCountsIdRoute
  '/inventory/counts/new': typeof AppInventoryCountsNewRoute
  '/inventory/transfers/$id': typeof AppInventoryTransfersIdRoute
  '/inventory/transfers/new': typeof AppInventoryTransfersNewRoute
  '/orders/$id/edit': typeof AppOrdersIdEditRoute
  '/orders/$id/exchange': typeof AppOrdersIdExchangeRoute
  '/orders/$id/return': typeof AppOrdersIdReturnRoute
  '/payments/cod/$id': typeof AppPaymentsCodIdRoute
  '/purchasing/orders/$id': typeof AppPurchasingOrdersIdRoute
  '/purchasing/orders/new': typeof AppPurchasingOrdersNewRoute
  '/purchasing/receipts/$id': typeof AppPurchasingReceiptsIdRoute
  '/purchasing/receipts/new': typeof AppPurchasingReceiptsNewRoute
  '/purchasing/returns/$id': typeof AppPurchasingReturnsIdRoute
  '/purchasing/returns/new': typeof AppPurchasingReturnsNewRoute
  '/purchasing/suppliers/$id': typeof AppPurchasingSuppliersIdRoute
  '/reports/$group/$report': typeof AppReportsGroupReportRoute
  '/reports/exports/$id': typeof AppReportsExportsIdRoute
  '/settings/locations/$id': typeof AppSettingsLocationsIdRoute
  '/settings/pages/$id': typeof AppSettingsPagesIdRoute
  '/catalog/import/': typeof AppCatalogImportIndexRoute
  '/catalog/products/': typeof AppCatalogProductsIndexRoute
  '/inventory/adjustments/': typeof AppInventoryAdjustmentsIndexRoute
  '/inventory/counts/': typeof AppInventoryCountsIndexRoute
  '/inventory/transfers/': typeof AppInventoryTransfersIndexRoute
  '/payments/cod/': typeof AppPaymentsCodIndexRoute
  '/purchasing/orders/': typeof AppPurchasingOrdersIndexRoute
  '/purchasing/receipts/': typeof AppPurchasingReceiptsIndexRoute
  '/purchasing/returns/': typeof AppPurchasingReturnsIndexRoute
  '/purchasing/suppliers/': typeof AppPurchasingSuppliersIndexRoute
  '/settings/locations/': typeof AppSettingsLocationsIndexRoute
  '/settings/pages/': typeof AppSettingsPagesIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof AppIndexRoute
  '/sandbox-enter': typeof SandboxEnterRoute
  '/audit-logs': typeof AppAuditLogsRoute
  '/help': typeof AppHelpRoute
  '/forgot-password': typeof AuthForgotPasswordRoute
  '/reset-password': typeof AuthResetPasswordRoute
  '/sign-up': typeof AuthSignUpRoute
  '/support-sign-in': typeof AuthSupportSignInRoute
  '/c/$token': typeof CTokenRoute
  '/accounting/cashbook': typeof AppAccountingCashbookRoute
  '/accounting/expenses': typeof AppAccountingExpensesRoute
  '/catalog/setup': typeof AppCatalogSetupRoute
  '/customers/$id': typeof AppCustomersIdRoute
  '/customers/online-accounts': typeof AppCustomersOnlineAccountsRoute
  '/inventory/history': typeof AppInventoryHistoryRoute
  '/inventory/stock': typeof AppInventoryStockRoute
  '/invitations/$token': typeof AppInvitationsTokenRoute
  '/marketing/coupons': typeof AppMarketingCouponsRoute
  '/orders/$id': typeof AppOrdersIdRoute
  '/orders/calls': typeof AppOrdersCallsRoute
  '/orders/new': typeof AppOrdersNewRoute
  '/orders/returns': typeof AppOrdersReturnsRoute
  '/orders/rto': typeof AppOrdersRtoRoute
  '/payments/accounts': typeof AppPaymentsAccountsRoute
  '/pos/devices': typeof AppPosDevicesRoute
  '/pos/reviews': typeof AppPosReviewsRoute
  '/purchasing/payables': typeof AppPurchasingPayablesRoute
  '/settings/appearance': typeof AppSettingsAppearanceRoute
  '/settings/billing': typeof AppSettingsBillingRoute
  '/settings/business': typeof AppSettingsBusinessRoute
  '/settings/couriers': typeof AppSettingsCouriersRoute
  '/settings/data': typeof AppSettingsDataRoute
  '/settings/delivery-zones': typeof AppSettingsDeliveryZonesRoute
  '/settings/fraud': typeof AppSettingsFraudRoute
  '/settings/online-store': typeof AppSettingsOnlineStoreRoute
  '/settings/security': typeof AppSettingsSecurityRoute
  '/settings/sessions': typeof AppSettingsSessionsRoute
  '/settings/staff': typeof AppSettingsStaffRoute
  '/settings/support': typeof AppSettingsSupportRoute
  '/settings/themes': typeof AppSettingsThemesRoute
  '/sign-in/otp': typeof AuthSignInOtpRoute
  '/sign-in/totp': typeof AuthSignInTotpRoute
  '/customers': typeof AppCustomersIndexRoute
  '/orders': typeof AppOrdersIndexRoute
  '/payments': typeof AppPaymentsIndexRoute
  '/reports': typeof AppReportsIndexRoute
  '/sign-in': typeof AuthSignInIndexRoute
  '/catalog/import/$id': typeof AppCatalogImportIdRoute
  '/catalog/products/$id': typeof AppCatalogProductsIdRoute
  '/catalog/products/new': typeof AppCatalogProductsNewRoute
  '/inventory/adjustments/$id': typeof AppInventoryAdjustmentsIdRoute
  '/inventory/adjustments/new': typeof AppInventoryAdjustmentsNewRoute
  '/inventory/counts/$id': typeof AppInventoryCountsIdRoute
  '/inventory/counts/new': typeof AppInventoryCountsNewRoute
  '/inventory/transfers/$id': typeof AppInventoryTransfersIdRoute
  '/inventory/transfers/new': typeof AppInventoryTransfersNewRoute
  '/orders/$id/edit': typeof AppOrdersIdEditRoute
  '/orders/$id/exchange': typeof AppOrdersIdExchangeRoute
  '/orders/$id/return': typeof AppOrdersIdReturnRoute
  '/payments/cod/$id': typeof AppPaymentsCodIdRoute
  '/purchasing/orders/$id': typeof AppPurchasingOrdersIdRoute
  '/purchasing/orders/new': typeof AppPurchasingOrdersNewRoute
  '/purchasing/receipts/$id': typeof AppPurchasingReceiptsIdRoute
  '/purchasing/receipts/new': typeof AppPurchasingReceiptsNewRoute
  '/purchasing/returns/$id': typeof AppPurchasingReturnsIdRoute
  '/purchasing/returns/new': typeof AppPurchasingReturnsNewRoute
  '/purchasing/suppliers/$id': typeof AppPurchasingSuppliersIdRoute
  '/reports/$group/$report': typeof AppReportsGroupReportRoute
  '/reports/exports/$id': typeof AppReportsExportsIdRoute
  '/settings/locations/$id': typeof AppSettingsLocationsIdRoute
  '/settings/pages/$id': typeof AppSettingsPagesIdRoute
  '/catalog/import': typeof AppCatalogImportIndexRoute
  '/catalog/products': typeof AppCatalogProductsIndexRoute
  '/inventory/adjustments': typeof AppInventoryAdjustmentsIndexRoute
  '/inventory/counts': typeof AppInventoryCountsIndexRoute
  '/inventory/transfers': typeof AppInventoryTransfersIndexRoute
  '/payments/cod': typeof AppPaymentsCodIndexRoute
  '/purchasing/orders': typeof AppPurchasingOrdersIndexRoute
  '/purchasing/receipts': typeof AppPurchasingReceiptsIndexRoute
  '/purchasing/returns': typeof AppPurchasingReturnsIndexRoute
  '/purchasing/suppliers': typeof AppPurchasingSuppliersIndexRoute
  '/settings/locations': typeof AppSettingsLocationsIndexRoute
  '/settings/pages': typeof AppSettingsPagesIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/_auth': typeof AuthRouteWithChildren
  '/sandbox-enter': typeof SandboxEnterRoute
  '/_app/audit-logs': typeof AppAuditLogsRoute
  '/_app/help': typeof AppHelpRoute
  '/_auth/forgot-password': typeof AuthForgotPasswordRoute
  '/_auth/reset-password': typeof AuthResetPasswordRoute
  '/_auth/sign-up': typeof AuthSignUpRoute
  '/_auth/support-sign-in': typeof AuthSupportSignInRoute
  '/c/$token': typeof CTokenRoute
  '/_app/': typeof AppIndexRoute
  '/_app/accounting/cashbook': typeof AppAccountingCashbookRoute
  '/_app/accounting/expenses': typeof AppAccountingExpensesRoute
  '/_app/catalog/setup': typeof AppCatalogSetupRoute
  '/_app/customers/$id': typeof AppCustomersIdRoute
  '/_app/customers/online-accounts': typeof AppCustomersOnlineAccountsRoute
  '/_app/inventory/history': typeof AppInventoryHistoryRoute
  '/_app/inventory/stock': typeof AppInventoryStockRoute
  '/_app/invitations/$token': typeof AppInvitationsTokenRoute
  '/_app/marketing/coupons': typeof AppMarketingCouponsRoute
  '/_app/orders/$id': typeof AppOrdersIdRoute
  '/_app/orders/calls': typeof AppOrdersCallsRoute
  '/_app/orders/new': typeof AppOrdersNewRoute
  '/_app/orders/returns': typeof AppOrdersReturnsRoute
  '/_app/orders/rto': typeof AppOrdersRtoRoute
  '/_app/payments/accounts': typeof AppPaymentsAccountsRoute
  '/_app/pos/devices': typeof AppPosDevicesRoute
  '/_app/pos/reviews': typeof AppPosReviewsRoute
  '/_app/purchasing/payables': typeof AppPurchasingPayablesRoute
  '/_app/settings/appearance': typeof AppSettingsAppearanceRoute
  '/_app/settings/billing': typeof AppSettingsBillingRoute
  '/_app/settings/business': typeof AppSettingsBusinessRoute
  '/_app/settings/couriers': typeof AppSettingsCouriersRoute
  '/_app/settings/data': typeof AppSettingsDataRoute
  '/_app/settings/delivery-zones': typeof AppSettingsDeliveryZonesRoute
  '/_app/settings/fraud': typeof AppSettingsFraudRoute
  '/_app/settings/online-store': typeof AppSettingsOnlineStoreRoute
  '/_app/settings/security': typeof AppSettingsSecurityRoute
  '/_app/settings/sessions': typeof AppSettingsSessionsRoute
  '/_app/settings/staff': typeof AppSettingsStaffRoute
  '/_app/settings/support': typeof AppSettingsSupportRoute
  '/_app/settings/themes': typeof AppSettingsThemesRoute
  '/_auth/sign-in/otp': typeof AuthSignInOtpRoute
  '/_auth/sign-in/totp': typeof AuthSignInTotpRoute
  '/_app/customers/': typeof AppCustomersIndexRoute
  '/_app/orders/': typeof AppOrdersIndexRoute
  '/_app/payments/': typeof AppPaymentsIndexRoute
  '/_app/reports/': typeof AppReportsIndexRoute
  '/_auth/sign-in/': typeof AuthSignInIndexRoute
  '/_app/catalog/import/$id': typeof AppCatalogImportIdRoute
  '/_app/catalog/products/$id': typeof AppCatalogProductsIdRoute
  '/_app/catalog/products/new': typeof AppCatalogProductsNewRoute
  '/_app/inventory/adjustments/$id': typeof AppInventoryAdjustmentsIdRoute
  '/_app/inventory/adjustments/new': typeof AppInventoryAdjustmentsNewRoute
  '/_app/inventory/counts/$id': typeof AppInventoryCountsIdRoute
  '/_app/inventory/counts/new': typeof AppInventoryCountsNewRoute
  '/_app/inventory/transfers/$id': typeof AppInventoryTransfersIdRoute
  '/_app/inventory/transfers/new': typeof AppInventoryTransfersNewRoute
  '/_app/orders/$id_/edit': typeof AppOrdersIdEditRoute
  '/_app/orders/$id_/exchange': typeof AppOrdersIdExchangeRoute
  '/_app/orders/$id_/return': typeof AppOrdersIdReturnRoute
  '/_app/payments/cod/$id': typeof AppPaymentsCodIdRoute
  '/_app/purchasing/orders/$id': typeof AppPurchasingOrdersIdRoute
  '/_app/purchasing/orders/new': typeof AppPurchasingOrdersNewRoute
  '/_app/purchasing/receipts/$id': typeof AppPurchasingReceiptsIdRoute
  '/_app/purchasing/receipts/new': typeof AppPurchasingReceiptsNewRoute
  '/_app/purchasing/returns/$id': typeof AppPurchasingReturnsIdRoute
  '/_app/purchasing/returns/new': typeof AppPurchasingReturnsNewRoute
  '/_app/purchasing/suppliers/$id': typeof AppPurchasingSuppliersIdRoute
  '/_app/reports/$group/$report': typeof AppReportsGroupReportRoute
  '/_app/reports/exports/$id': typeof AppReportsExportsIdRoute
  '/_app/settings/locations/$id': typeof AppSettingsLocationsIdRoute
  '/_app/settings/pages/$id': typeof AppSettingsPagesIdRoute
  '/_app/catalog/import/': typeof AppCatalogImportIndexRoute
  '/_app/catalog/products/': typeof AppCatalogProductsIndexRoute
  '/_app/inventory/adjustments/': typeof AppInventoryAdjustmentsIndexRoute
  '/_app/inventory/counts/': typeof AppInventoryCountsIndexRoute
  '/_app/inventory/transfers/': typeof AppInventoryTransfersIndexRoute
  '/_app/payments/cod/': typeof AppPaymentsCodIndexRoute
  '/_app/purchasing/orders/': typeof AppPurchasingOrdersIndexRoute
  '/_app/purchasing/receipts/': typeof AppPurchasingReceiptsIndexRoute
  '/_app/purchasing/returns/': typeof AppPurchasingReturnsIndexRoute
  '/_app/purchasing/suppliers/': typeof AppPurchasingSuppliersIndexRoute
  '/_app/settings/locations/': typeof AppSettingsLocationsIndexRoute
  '/_app/settings/pages/': typeof AppSettingsPagesIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/sandbox-enter'
    | '/audit-logs'
    | '/help'
    | '/forgot-password'
    | '/reset-password'
    | '/sign-up'
    | '/support-sign-in'
    | '/c/$token'
    | '/accounting/cashbook'
    | '/accounting/expenses'
    | '/catalog/setup'
    | '/customers/$id'
    | '/customers/online-accounts'
    | '/inventory/history'
    | '/inventory/stock'
    | '/invitations/$token'
    | '/marketing/coupons'
    | '/orders/$id'
    | '/orders/calls'
    | '/orders/new'
    | '/orders/returns'
    | '/orders/rto'
    | '/payments/accounts'
    | '/pos/devices'
    | '/pos/reviews'
    | '/purchasing/payables'
    | '/settings/appearance'
    | '/settings/billing'
    | '/settings/business'
    | '/settings/couriers'
    | '/settings/data'
    | '/settings/delivery-zones'
    | '/settings/fraud'
    | '/settings/online-store'
    | '/settings/security'
    | '/settings/sessions'
    | '/settings/staff'
    | '/settings/support'
    | '/settings/themes'
    | '/sign-in/otp'
    | '/sign-in/totp'
    | '/customers/'
    | '/orders/'
    | '/payments/'
    | '/reports/'
    | '/sign-in/'
    | '/catalog/import/$id'
    | '/catalog/products/$id'
    | '/catalog/products/new'
    | '/inventory/adjustments/$id'
    | '/inventory/adjustments/new'
    | '/inventory/counts/$id'
    | '/inventory/counts/new'
    | '/inventory/transfers/$id'
    | '/inventory/transfers/new'
    | '/orders/$id/edit'
    | '/orders/$id/exchange'
    | '/orders/$id/return'
    | '/payments/cod/$id'
    | '/purchasing/orders/$id'
    | '/purchasing/orders/new'
    | '/purchasing/receipts/$id'
    | '/purchasing/receipts/new'
    | '/purchasing/returns/$id'
    | '/purchasing/returns/new'
    | '/purchasing/suppliers/$id'
    | '/reports/$group/$report'
    | '/reports/exports/$id'
    | '/settings/locations/$id'
    | '/settings/pages/$id'
    | '/catalog/import/'
    | '/catalog/products/'
    | '/inventory/adjustments/'
    | '/inventory/counts/'
    | '/inventory/transfers/'
    | '/payments/cod/'
    | '/purchasing/orders/'
    | '/purchasing/receipts/'
    | '/purchasing/returns/'
    | '/purchasing/suppliers/'
    | '/settings/locations/'
    | '/settings/pages/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/sandbox-enter'
    | '/audit-logs'
    | '/help'
    | '/forgot-password'
    | '/reset-password'
    | '/sign-up'
    | '/support-sign-in'
    | '/c/$token'
    | '/accounting/cashbook'
    | '/accounting/expenses'
    | '/catalog/setup'
    | '/customers/$id'
    | '/customers/online-accounts'
    | '/inventory/history'
    | '/inventory/stock'
    | '/invitations/$token'
    | '/marketing/coupons'
    | '/orders/$id'
    | '/orders/calls'
    | '/orders/new'
    | '/orders/returns'
    | '/orders/rto'
    | '/payments/accounts'
    | '/pos/devices'
    | '/pos/reviews'
    | '/purchasing/payables'
    | '/settings/appearance'
    | '/settings/billing'
    | '/settings/business'
    | '/settings/couriers'
    | '/settings/data'
    | '/settings/delivery-zones'
    | '/settings/fraud'
    | '/settings/online-store'
    | '/settings/security'
    | '/settings/sessions'
    | '/settings/staff'
    | '/settings/support'
    | '/settings/themes'
    | '/sign-in/otp'
    | '/sign-in/totp'
    | '/customers'
    | '/orders'
    | '/payments'
    | '/reports'
    | '/sign-in'
    | '/catalog/import/$id'
    | '/catalog/products/$id'
    | '/catalog/products/new'
    | '/inventory/adjustments/$id'
    | '/inventory/adjustments/new'
    | '/inventory/counts/$id'
    | '/inventory/counts/new'
    | '/inventory/transfers/$id'
    | '/inventory/transfers/new'
    | '/orders/$id/edit'
    | '/orders/$id/exchange'
    | '/orders/$id/return'
    | '/payments/cod/$id'
    | '/purchasing/orders/$id'
    | '/purchasing/orders/new'
    | '/purchasing/receipts/$id'
    | '/purchasing/receipts/new'
    | '/purchasing/returns/$id'
    | '/purchasing/returns/new'
    | '/purchasing/suppliers/$id'
    | '/reports/$group/$report'
    | '/reports/exports/$id'
    | '/settings/locations/$id'
    | '/settings/pages/$id'
    | '/catalog/import'
    | '/catalog/products'
    | '/inventory/adjustments'
    | '/inventory/counts'
    | '/inventory/transfers'
    | '/payments/cod'
    | '/purchasing/orders'
    | '/purchasing/receipts'
    | '/purchasing/returns'
    | '/purchasing/suppliers'
    | '/settings/locations'
    | '/settings/pages'
  id:
    | '__root__'
    | '/_app'
    | '/_auth'
    | '/sandbox-enter'
    | '/_app/audit-logs'
    | '/_app/help'
    | '/_auth/forgot-password'
    | '/_auth/reset-password'
    | '/_auth/sign-up'
    | '/_auth/support-sign-in'
    | '/c/$token'
    | '/_app/'
    | '/_app/accounting/cashbook'
    | '/_app/accounting/expenses'
    | '/_app/catalog/setup'
    | '/_app/customers/$id'
    | '/_app/customers/online-accounts'
    | '/_app/inventory/history'
    | '/_app/inventory/stock'
    | '/_app/invitations/$token'
    | '/_app/marketing/coupons'
    | '/_app/orders/$id'
    | '/_app/orders/calls'
    | '/_app/orders/new'
    | '/_app/orders/returns'
    | '/_app/orders/rto'
    | '/_app/payments/accounts'
    | '/_app/pos/devices'
    | '/_app/pos/reviews'
    | '/_app/purchasing/payables'
    | '/_app/settings/appearance'
    | '/_app/settings/billing'
    | '/_app/settings/business'
    | '/_app/settings/couriers'
    | '/_app/settings/data'
    | '/_app/settings/delivery-zones'
    | '/_app/settings/fraud'
    | '/_app/settings/online-store'
    | '/_app/settings/security'
    | '/_app/settings/sessions'
    | '/_app/settings/staff'
    | '/_app/settings/support'
    | '/_app/settings/themes'
    | '/_auth/sign-in/otp'
    | '/_auth/sign-in/totp'
    | '/_app/customers/'
    | '/_app/orders/'
    | '/_app/payments/'
    | '/_app/reports/'
    | '/_auth/sign-in/'
    | '/_app/catalog/import/$id'
    | '/_app/catalog/products/$id'
    | '/_app/catalog/products/new'
    | '/_app/inventory/adjustments/$id'
    | '/_app/inventory/adjustments/new'
    | '/_app/inventory/counts/$id'
    | '/_app/inventory/counts/new'
    | '/_app/inventory/transfers/$id'
    | '/_app/inventory/transfers/new'
    | '/_app/orders/$id_/edit'
    | '/_app/orders/$id_/exchange'
    | '/_app/orders/$id_/return'
    | '/_app/payments/cod/$id'
    | '/_app/purchasing/orders/$id'
    | '/_app/purchasing/orders/new'
    | '/_app/purchasing/receipts/$id'
    | '/_app/purchasing/receipts/new'
    | '/_app/purchasing/returns/$id'
    | '/_app/purchasing/returns/new'
    | '/_app/purchasing/suppliers/$id'
    | '/_app/reports/$group/$report'
    | '/_app/reports/exports/$id'
    | '/_app/settings/locations/$id'
    | '/_app/settings/pages/$id'
    | '/_app/catalog/import/'
    | '/_app/catalog/products/'
    | '/_app/inventory/adjustments/'
    | '/_app/inventory/counts/'
    | '/_app/inventory/transfers/'
    | '/_app/payments/cod/'
    | '/_app/purchasing/orders/'
    | '/_app/purchasing/receipts/'
    | '/_app/purchasing/returns/'
    | '/_app/purchasing/suppliers/'
    | '/_app/settings/locations/'
    | '/_app/settings/pages/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  AuthRoute: typeof AuthRouteWithChildren
  SandboxEnterRoute: typeof SandboxEnterRoute
  CTokenRoute: typeof CTokenRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sandbox-enter': {
      id: '/sandbox-enter'
      path: '/sandbox-enter'
      fullPath: '/sandbox-enter'
      preLoaderRoute: typeof SandboxEnterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/audit-logs': {
      id: '/_app/audit-logs'
      path: '/audit-logs'
      fullPath: '/audit-logs'
      preLoaderRoute: typeof AppAuditLogsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/help': {
      id: '/_app/help'
      path: '/help'
      fullPath: '/help'
      preLoaderRoute: typeof AppHelpRouteImport
      parentRoute: typeof AppRoute
    }
    '/_auth/forgot-password': {
      id: '/_auth/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof AuthForgotPasswordRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/reset-password': {
      id: '/_auth/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof AuthResetPasswordRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/sign-up': {
      id: '/_auth/sign-up'
      path: '/sign-up'
      fullPath: '/sign-up'
      preLoaderRoute: typeof AuthSignUpRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/support-sign-in': {
      id: '/_auth/support-sign-in'
      path: '/support-sign-in'
      fullPath: '/support-sign-in'
      preLoaderRoute: typeof AuthSupportSignInRouteImport
      parentRoute: typeof AuthRoute
    }
    '/c/$token': {
      id: '/c/$token'
      path: '/c/$token'
      fullPath: '/c/$token'
      preLoaderRoute: typeof CTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/accounting/cashbook': {
      id: '/_app/accounting/cashbook'
      path: '/accounting/cashbook'
      fullPath: '/accounting/cashbook'
      preLoaderRoute: typeof AppAccountingCashbookRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/accounting/expenses': {
      id: '/_app/accounting/expenses'
      path: '/accounting/expenses'
      fullPath: '/accounting/expenses'
      preLoaderRoute: typeof AppAccountingExpensesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/catalog/setup': {
      id: '/_app/catalog/setup'
      path: '/catalog/setup'
      fullPath: '/catalog/setup'
      preLoaderRoute: typeof AppCatalogSetupRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/customers/': {
      id: '/_app/customers/'
      path: '/customers'
      fullPath: '/customers/'
      preLoaderRoute: typeof AppCustomersIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/customers/$id': {
      id: '/_app/customers/$id'
      path: '/customers/$id'
      fullPath: '/customers/$id'
      preLoaderRoute: typeof AppCustomersIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/customers/online-accounts': {
      id: '/_app/customers/online-accounts'
      path: '/customers/online-accounts'
      fullPath: '/customers/online-accounts'
      preLoaderRoute: typeof AppCustomersOnlineAccountsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/inventory/history': {
      id: '/_app/inventory/history'
      path: '/inventory/history'
      fullPath: '/inventory/history'
      preLoaderRoute: typeof AppInventoryHistoryRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/inventory/stock': {
      id: '/_app/inventory/stock'
      path: '/inventory/stock'
      fullPath: '/inventory/stock'
      preLoaderRoute: typeof AppInventoryStockRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/invitations/$token': {
      id: '/_app/invitations/$token'
      path: '/invitations/$token'
      fullPath: '/invitations/$token'
      preLoaderRoute: typeof AppInvitationsTokenRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/marketing/coupons': {
      id: '/_app/marketing/coupons'
      path: '/marketing/coupons'
      fullPath: '/marketing/coupons'
      preLoaderRoute: typeof AppMarketingCouponsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/orders/': {
      id: '/_app/orders/'
      path: '/orders'
      fullPath: '/orders/'
      preLoaderRoute: typeof AppOrdersIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/orders/$id': {
      id: '/_app/orders/$id'
      path: '/orders/$id'
      fullPath: '/orders/$id'
      preLoaderRoute: typeof AppOrdersIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/orders/calls': {
      id: '/_app/orders/calls'
      path: '/orders/calls'
      fullPath: '/orders/calls'
      preLoaderRoute: typeof AppOrdersCallsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/orders/new': {
      id: '/_app/orders/new'
      path: '/orders/new'
      fullPath: '/orders/new'
      preLoaderRoute: typeof AppOrdersNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/orders/returns': {
      id: '/_app/orders/returns'
      path: '/orders/returns'
      fullPath: '/orders/returns'
      preLoaderRoute: typeof AppOrdersReturnsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/orders/rto': {
      id: '/_app/orders/rto'
      path: '/orders/rto'
      fullPath: '/orders/rto'
      preLoaderRoute: typeof AppOrdersRtoRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/payments/': {
      id: '/_app/payments/'
      path: '/payments'
      fullPath: '/payments/'
      preLoaderRoute: typeof AppPaymentsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/payments/accounts': {
      id: '/_app/payments/accounts'
      path: '/payments/accounts'
      fullPath: '/payments/accounts'
      preLoaderRoute: typeof AppPaymentsAccountsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/pos/devices': {
      id: '/_app/pos/devices'
      path: '/pos/devices'
      fullPath: '/pos/devices'
      preLoaderRoute: typeof AppPosDevicesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/pos/reviews': {
      id: '/_app/pos/reviews'
      path: '/pos/reviews'
      fullPath: '/pos/reviews'
      preLoaderRoute: typeof AppPosReviewsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/purchasing/payables': {
      id: '/_app/purchasing/payables'
      path: '/purchasing/payables'
      fullPath: '/purchasing/payables'
      preLoaderRoute: typeof AppPurchasingPayablesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/reports/': {
      id: '/_app/reports/'
      path: '/reports'
      fullPath: '/reports/'
      preLoaderRoute: typeof AppReportsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/appearance': {
      id: '/_app/settings/appearance'
      path: '/settings/appearance'
      fullPath: '/settings/appearance'
      preLoaderRoute: typeof AppSettingsAppearanceRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/billing': {
      id: '/_app/settings/billing'
      path: '/settings/billing'
      fullPath: '/settings/billing'
      preLoaderRoute: typeof AppSettingsBillingRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/business': {
      id: '/_app/settings/business'
      path: '/settings/business'
      fullPath: '/settings/business'
      preLoaderRoute: typeof AppSettingsBusinessRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/couriers': {
      id: '/_app/settings/couriers'
      path: '/settings/couriers'
      fullPath: '/settings/couriers'
      preLoaderRoute: typeof AppSettingsCouriersRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/data': {
      id: '/_app/settings/data'
      path: '/settings/data'
      fullPath: '/settings/data'
      preLoaderRoute: typeof AppSettingsDataRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/delivery-zones': {
      id: '/_app/settings/delivery-zones'
      path: '/settings/delivery-zones'
      fullPath: '/settings/delivery-zones'
      preLoaderRoute: typeof AppSettingsDeliveryZonesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/fraud': {
      id: '/_app/settings/fraud'
      path: '/settings/fraud'
      fullPath: '/settings/fraud'
      preLoaderRoute: typeof AppSettingsFraudRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/online-store': {
      id: '/_app/settings/online-store'
      path: '/settings/online-store'
      fullPath: '/settings/online-store'
      preLoaderRoute: typeof AppSettingsOnlineStoreRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/security': {
      id: '/_app/settings/security'
      path: '/settings/security'
      fullPath: '/settings/security'
      preLoaderRoute: typeof AppSettingsSecurityRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/sessions': {
      id: '/_app/settings/sessions'
      path: '/settings/sessions'
      fullPath: '/settings/sessions'
      preLoaderRoute: typeof AppSettingsSessionsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/staff': {
      id: '/_app/settings/staff'
      path: '/settings/staff'
      fullPath: '/settings/staff'
      preLoaderRoute: typeof AppSettingsStaffRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/support': {
      id: '/_app/settings/support'
      path: '/settings/support'
      fullPath: '/settings/support'
      preLoaderRoute: typeof AppSettingsSupportRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/themes': {
      id: '/_app/settings/themes'
      path: '/settings/themes'
      fullPath: '/settings/themes'
      preLoaderRoute: typeof AppSettingsThemesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_auth/sign-in/': {
      id: '/_auth/sign-in/'
      path: '/sign-in'
      fullPath: '/sign-in/'
      preLoaderRoute: typeof AuthSignInIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/sign-in/otp': {
      id: '/_auth/sign-in/otp'
      path: '/sign-in/otp'
      fullPath: '/sign-in/otp'
      preLoaderRoute: typeof AuthSignInOtpRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/sign-in/totp': {
      id: '/_auth/sign-in/totp'
      path: '/sign-in/totp'
      fullPath: '/sign-in/totp'
      preLoaderRoute: typeof AuthSignInTotpRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_app/catalog/import/': {
      id: '/_app/catalog/import/'
      path: '/catalog/import'
      fullPath: '/catalog/import/'
      preLoaderRoute: typeof AppCatalogImportIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/catalog/import/$id': {
      id: '/_app/catalog/import/$id'
      path: '/catalog/import/$id'
      fullPath: '/catalog/import/$id'
      preLoaderRoute: typeof AppCatalogImportIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/catalog/products/': {
      id: '/_app/catalog/products/'
      path: '/catalog/products'
      fullPath: '/catalog/products/'
      preLoaderRoute: typeof AppCatalogProductsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/catalog/products/$id': {
      id: '/_app/catalog/products/$id'
      path: '/catalog/products/$id'
      fullPath: '/catalog/products/$id'
      preLoaderRoute: typeof AppCatalogProductsIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/catalog/products/new': {
      id: '/_app/catalog/products/new'
      path: '/catalog/products/new'
      fullPath: '/catalog/products/new'
      preLoaderRoute: typeof AppCatalogProductsNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/inventory/adjustments/': {
      id: '/_app/inventory/adjustments/'
      path: '/inventory/adjustments'
      fullPath: '/inventory/adjustments/'
      preLoaderRoute: typeof AppInventoryAdjustmentsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/inventory/adjustments/$id': {
      id: '/_app/inventory/adjustments/$id'
      path: '/inventory/adjustments/$id'
      fullPath: '/inventory/adjustments/$id'
      preLoaderRoute: typeof AppInventoryAdjustmentsIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/inventory/adjustments/new': {
      id: '/_app/inventory/adjustments/new'
      path: '/inventory/adjustments/new'
      fullPath: '/inventory/adjustments/new'
      preLoaderRoute: typeof AppInventoryAdjustmentsNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/inventory/counts/': {
      id: '/_app/inventory/counts/'
      path: '/inventory/counts'
      fullPath: '/inventory/counts/'
      preLoaderRoute: typeof AppInventoryCountsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/inventory/counts/$id': {
      id: '/_app/inventory/counts/$id'
      path: '/inventory/counts/$id'
      fullPath: '/inventory/counts/$id'
      preLoaderRoute: typeof AppInventoryCountsIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/inventory/counts/new': {
      id: '/_app/inventory/counts/new'
      path: '/inventory/counts/new'
      fullPath: '/inventory/counts/new'
      preLoaderRoute: typeof AppInventoryCountsNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/inventory/transfers/': {
      id: '/_app/inventory/transfers/'
      path: '/inventory/transfers'
      fullPath: '/inventory/transfers/'
      preLoaderRoute: typeof AppInventoryTransfersIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/inventory/transfers/$id': {
      id: '/_app/inventory/transfers/$id'
      path: '/inventory/transfers/$id'
      fullPath: '/inventory/transfers/$id'
      preLoaderRoute: typeof AppInventoryTransfersIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/inventory/transfers/new': {
      id: '/_app/inventory/transfers/new'
      path: '/inventory/transfers/new'
      fullPath: '/inventory/transfers/new'
      preLoaderRoute: typeof AppInventoryTransfersNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/orders/$id_/edit': {
      id: '/_app/orders/$id_/edit'
      path: '/orders/$id/edit'
      fullPath: '/orders/$id/edit'
      preLoaderRoute: typeof AppOrdersIdEditRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/orders/$id_/exchange': {
      id: '/_app/orders/$id_/exchange'
      path: '/orders/$id/exchange'
      fullPath: '/orders/$id/exchange'
      preLoaderRoute: typeof AppOrdersIdExchangeRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/orders/$id_/return': {
      id: '/_app/orders/$id_/return'
      path: '/orders/$id/return'
      fullPath: '/orders/$id/return'
      preLoaderRoute: typeof AppOrdersIdReturnRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/payments/cod/': {
      id: '/_app/payments/cod/'
      path: '/payments/cod'
      fullPath: '/payments/cod/'
      preLoaderRoute: typeof AppPaymentsCodIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/payments/cod/$id': {
      id: '/_app/payments/cod/$id'
      path: '/payments/cod/$id'
      fullPath: '/payments/cod/$id'
      preLoaderRoute: typeof AppPaymentsCodIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/purchasing/orders/': {
      id: '/_app/purchasing/orders/'
      path: '/purchasing/orders'
      fullPath: '/purchasing/orders/'
      preLoaderRoute: typeof AppPurchasingOrdersIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/purchasing/orders/$id': {
      id: '/_app/purchasing/orders/$id'
      path: '/purchasing/orders/$id'
      fullPath: '/purchasing/orders/$id'
      preLoaderRoute: typeof AppPurchasingOrdersIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/purchasing/orders/new': {
      id: '/_app/purchasing/orders/new'
      path: '/purchasing/orders/new'
      fullPath: '/purchasing/orders/new'
      preLoaderRoute: typeof AppPurchasingOrdersNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/purchasing/receipts/': {
      id: '/_app/purchasing/receipts/'
      path: '/purchasing/receipts'
      fullPath: '/purchasing/receipts/'
      preLoaderRoute: typeof AppPurchasingReceiptsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/purchasing/receipts/$id': {
      id: '/_app/purchasing/receipts/$id'
      path: '/purchasing/receipts/$id'
      fullPath: '/purchasing/receipts/$id'
      preLoaderRoute: typeof AppPurchasingReceiptsIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/purchasing/receipts/new': {
      id: '/_app/purchasing/receipts/new'
      path: '/purchasing/receipts/new'
      fullPath: '/purchasing/receipts/new'
      preLoaderRoute: typeof AppPurchasingReceiptsNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/purchasing/returns/': {
      id: '/_app/purchasing/returns/'
      path: '/purchasing/returns'
      fullPath: '/purchasing/returns/'
      preLoaderRoute: typeof AppPurchasingReturnsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/purchasing/returns/$id': {
      id: '/_app/purchasing/returns/$id'
      path: '/purchasing/returns/$id'
      fullPath: '/purchasing/returns/$id'
      preLoaderRoute: typeof AppPurchasingReturnsIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/purchasing/returns/new': {
      id: '/_app/purchasing/returns/new'
      path: '/purchasing/returns/new'
      fullPath: '/purchasing/returns/new'
      preLoaderRoute: typeof AppPurchasingReturnsNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/purchasing/suppliers/': {
      id: '/_app/purchasing/suppliers/'
      path: '/purchasing/suppliers'
      fullPath: '/purchasing/suppliers/'
      preLoaderRoute: typeof AppPurchasingSuppliersIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/purchasing/suppliers/$id': {
      id: '/_app/purchasing/suppliers/$id'
      path: '/purchasing/suppliers/$id'
      fullPath: '/purchasing/suppliers/$id'
      preLoaderRoute: typeof AppPurchasingSuppliersIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/reports/$group/$report': {
      id: '/_app/reports/$group/$report'
      path: '/reports/$group/$report'
      fullPath: '/reports/$group/$report'
      preLoaderRoute: typeof AppReportsGroupReportRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/reports/exports/$id': {
      id: '/_app/reports/exports/$id'
      path: '/reports/exports/$id'
      fullPath: '/reports/exports/$id'
      preLoaderRoute: typeof AppReportsExportsIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/locations/': {
      id: '/_app/settings/locations/'
      path: '/settings/locations'
      fullPath: '/settings/locations/'
      preLoaderRoute: typeof AppSettingsLocationsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/locations/$id': {
      id: '/_app/settings/locations/$id'
      path: '/settings/locations/$id'
      fullPath: '/settings/locations/$id'
      preLoaderRoute: typeof AppSettingsLocationsIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/pages/': {
      id: '/_app/settings/pages/'
      path: '/settings/pages'
      fullPath: '/settings/pages/'
      preLoaderRoute: typeof AppSettingsPagesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/pages/$id': {
      id: '/_app/settings/pages/$id'
      path: '/settings/pages/$id'
      fullPath: '/settings/pages/$id'
      preLoaderRoute: typeof AppSettingsPagesIdRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppRouteChildren {
  AppAuditLogsRoute: typeof AppAuditLogsRoute
  AppHelpRoute: typeof AppHelpRoute
  AppIndexRoute: typeof AppIndexRoute
  AppAccountingCashbookRoute: typeof AppAccountingCashbookRoute
  AppAccountingExpensesRoute: typeof AppAccountingExpensesRoute
  AppCatalogSetupRoute: typeof AppCatalogSetupRoute
  AppCustomersIdRoute: typeof AppCustomersIdRoute
  AppCustomersOnlineAccountsRoute: typeof AppCustomersOnlineAccountsRoute
  AppInventoryHistoryRoute: typeof AppInventoryHistoryRoute
  AppInventoryStockRoute: typeof AppInventoryStockRoute
  AppInvitationsTokenRoute: typeof AppInvitationsTokenRoute
  AppMarketingCouponsRoute: typeof AppMarketingCouponsRoute
  AppOrdersIdRoute: typeof AppOrdersIdRoute
  AppOrdersCallsRoute: typeof AppOrdersCallsRoute
  AppOrdersNewRoute: typeof AppOrdersNewRoute
  AppOrdersReturnsRoute: typeof AppOrdersReturnsRoute
  AppOrdersRtoRoute: typeof AppOrdersRtoRoute
  AppPaymentsAccountsRoute: typeof AppPaymentsAccountsRoute
  AppPosDevicesRoute: typeof AppPosDevicesRoute
  AppPosReviewsRoute: typeof AppPosReviewsRoute
  AppPurchasingPayablesRoute: typeof AppPurchasingPayablesRoute
  AppSettingsAppearanceRoute: typeof AppSettingsAppearanceRoute
  AppSettingsBillingRoute: typeof AppSettingsBillingRoute
  AppSettingsBusinessRoute: typeof AppSettingsBusinessRoute
  AppSettingsCouriersRoute: typeof AppSettingsCouriersRoute
  AppSettingsDataRoute: typeof AppSettingsDataRoute
  AppSettingsDeliveryZonesRoute: typeof AppSettingsDeliveryZonesRoute
  AppSettingsFraudRoute: typeof AppSettingsFraudRoute
  AppSettingsOnlineStoreRoute: typeof AppSettingsOnlineStoreRoute
  AppSettingsSecurityRoute: typeof AppSettingsSecurityRoute
  AppSettingsSessionsRoute: typeof AppSettingsSessionsRoute
  AppSettingsStaffRoute: typeof AppSettingsStaffRoute
  AppSettingsSupportRoute: typeof AppSettingsSupportRoute
  AppSettingsThemesRoute: typeof AppSettingsThemesRoute
  AppCustomersIndexRoute: typeof AppCustomersIndexRoute
  AppOrdersIndexRoute: typeof AppOrdersIndexRoute
  AppPaymentsIndexRoute: typeof AppPaymentsIndexRoute
  AppReportsIndexRoute: typeof AppReportsIndexRoute
  AppCatalogImportIdRoute: typeof AppCatalogImportIdRoute
  AppCatalogProductsIdRoute: typeof AppCatalogProductsIdRoute
  AppCatalogProductsNewRoute: typeof AppCatalogProductsNewRoute
  AppInventoryAdjustmentsIdRoute: typeof AppInventoryAdjustmentsIdRoute
  AppInventoryAdjustmentsNewRoute: typeof AppInventoryAdjustmentsNewRoute
  AppInventoryCountsIdRoute: typeof AppInventoryCountsIdRoute
  AppInventoryCountsNewRoute: typeof AppInventoryCountsNewRoute
  AppInventoryTransfersIdRoute: typeof AppInventoryTransfersIdRoute
  AppInventoryTransfersNewRoute: typeof AppInventoryTransfersNewRoute
  AppOrdersIdEditRoute: typeof AppOrdersIdEditRoute
  AppOrdersIdExchangeRoute: typeof AppOrdersIdExchangeRoute
  AppOrdersIdReturnRoute: typeof AppOrdersIdReturnRoute
  AppPaymentsCodIdRoute: typeof AppPaymentsCodIdRoute
  AppPurchasingOrdersIdRoute: typeof AppPurchasingOrdersIdRoute
  AppPurchasingOrdersNewRoute: typeof AppPurchasingOrdersNewRoute
  AppPurchasingReceiptsIdRoute: typeof AppPurchasingReceiptsIdRoute
  AppPurchasingReceiptsNewRoute: typeof AppPurchasingReceiptsNewRoute
  AppPurchasingReturnsIdRoute: typeof AppPurchasingReturnsIdRoute
  AppPurchasingReturnsNewRoute: typeof AppPurchasingReturnsNewRoute
  AppPurchasingSuppliersIdRoute: typeof AppPurchasingSuppliersIdRoute
  AppReportsGroupReportRoute: typeof AppReportsGroupReportRoute
  AppReportsExportsIdRoute: typeof AppReportsExportsIdRoute
  AppSettingsLocationsIdRoute: typeof AppSettingsLocationsIdRoute
  AppSettingsPagesIdRoute: typeof AppSettingsPagesIdRoute
  AppCatalogImportIndexRoute: typeof AppCatalogImportIndexRoute
  AppCatalogProductsIndexRoute: typeof AppCatalogProductsIndexRoute
  AppInventoryAdjustmentsIndexRoute: typeof AppInventoryAdjustmentsIndexRoute
  AppInventoryCountsIndexRoute: typeof AppInventoryCountsIndexRoute
  AppInventoryTransfersIndexRoute: typeof AppInventoryTransfersIndexRoute
  AppPaymentsCodIndexRoute: typeof AppPaymentsCodIndexRoute
  AppPurchasingOrdersIndexRoute: typeof AppPurchasingOrdersIndexRoute
  AppPurchasingReceiptsIndexRoute: typeof AppPurchasingReceiptsIndexRoute
  AppPurchasingReturnsIndexRoute: typeof AppPurchasingReturnsIndexRoute
  AppPurchasingSuppliersIndexRoute: typeof AppPurchasingSuppliersIndexRoute
  AppSettingsLocationsIndexRoute: typeof AppSettingsLocationsIndexRoute
  AppSettingsPagesIndexRoute: typeof AppSettingsPagesIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppAuditLogsRoute: AppAuditLogsRoute,
  AppHelpRoute: AppHelpRoute,
  AppIndexRoute: AppIndexRoute,
  AppAccountingCashbookRoute: AppAccountingCashbookRoute,
  AppAccountingExpensesRoute: AppAccountingExpensesRoute,
  AppCatalogSetupRoute: AppCatalogSetupRoute,
  AppCustomersIdRoute: AppCustomersIdRoute,
  AppCustomersOnlineAccountsRoute: AppCustomersOnlineAccountsRoute,
  AppInventoryHistoryRoute: AppInventoryHistoryRoute,
  AppInventoryStockRoute: AppInventoryStockRoute,
  AppInvitationsTokenRoute: AppInvitationsTokenRoute,
  AppMarketingCouponsRoute: AppMarketingCouponsRoute,
  AppOrdersIdRoute: AppOrdersIdRoute,
  AppOrdersCallsRoute: AppOrdersCallsRoute,
  AppOrdersNewRoute: AppOrdersNewRoute,
  AppOrdersReturnsRoute: AppOrdersReturnsRoute,
  AppOrdersRtoRoute: AppOrdersRtoRoute,
  AppPaymentsAccountsRoute: AppPaymentsAccountsRoute,
  AppPosDevicesRoute: AppPosDevicesRoute,
  AppPosReviewsRoute: AppPosReviewsRoute,
  AppPurchasingPayablesRoute: AppPurchasingPayablesRoute,
  AppSettingsAppearanceRoute: AppSettingsAppearanceRoute,
  AppSettingsBillingRoute: AppSettingsBillingRoute,
  AppSettingsBusinessRoute: AppSettingsBusinessRoute,
  AppSettingsCouriersRoute: AppSettingsCouriersRoute,
  AppSettingsDataRoute: AppSettingsDataRoute,
  AppSettingsDeliveryZonesRoute: AppSettingsDeliveryZonesRoute,
  AppSettingsFraudRoute: AppSettingsFraudRoute,
  AppSettingsOnlineStoreRoute: AppSettingsOnlineStoreRoute,
  AppSettingsSecurityRoute: AppSettingsSecurityRoute,
  AppSettingsSessionsRoute: AppSettingsSessionsRoute,
  AppSettingsStaffRoute: AppSettingsStaffRoute,
  AppSettingsSupportRoute: AppSettingsSupportRoute,
  AppSettingsThemesRoute: AppSettingsThemesRoute,
  AppCustomersIndexRoute: AppCustomersIndexRoute,
  AppOrdersIndexRoute: AppOrdersIndexRoute,
  AppPaymentsIndexRoute: AppPaymentsIndexRoute,
  AppReportsIndexRoute: AppReportsIndexRoute,
  AppCatalogImportIdRoute: AppCatalogImportIdRoute,
  AppCatalogProductsIdRoute: AppCatalogProductsIdRoute,
  AppCatalogProductsNewRoute: AppCatalogProductsNewRoute,
  AppInventoryAdjustmentsIdRoute: AppInventoryAdjustmentsIdRoute,
  AppInventoryAdjustmentsNewRoute: AppInventoryAdjustmentsNewRoute,
  AppInventoryCountsIdRoute: AppInventoryCountsIdRoute,
  AppInventoryCountsNewRoute: AppInventoryCountsNewRoute,
  AppInventoryTransfersIdRoute: AppInventoryTransfersIdRoute,
  AppInventoryTransfersNewRoute: AppInventoryTransfersNewRoute,
  AppOrdersIdEditRoute: AppOrdersIdEditRoute,
  AppOrdersIdExchangeRoute: AppOrdersIdExchangeRoute,
  AppOrdersIdReturnRoute: AppOrdersIdReturnRoute,
  AppPaymentsCodIdRoute: AppPaymentsCodIdRoute,
  AppPurchasingOrdersIdRoute: AppPurchasingOrdersIdRoute,
  AppPurchasingOrdersNewRoute: AppPurchasingOrdersNewRoute,
  AppPurchasingReceiptsIdRoute: AppPurchasingReceiptsIdRoute,
  AppPurchasingReceiptsNewRoute: AppPurchasingReceiptsNewRoute,
  AppPurchasingReturnsIdRoute: AppPurchasingReturnsIdRoute,
  AppPurchasingReturnsNewRoute: AppPurchasingReturnsNewRoute,
  AppPurchasingSuppliersIdRoute: AppPurchasingSuppliersIdRoute,
  AppReportsGroupReportRoute: AppReportsGroupReportRoute,
  AppReportsExportsIdRoute: AppReportsExportsIdRoute,
  AppSettingsLocationsIdRoute: AppSettingsLocationsIdRoute,
  AppSettingsPagesIdRoute: AppSettingsPagesIdRoute,
  AppCatalogImportIndexRoute: AppCatalogImportIndexRoute,
  AppCatalogProductsIndexRoute: AppCatalogProductsIndexRoute,
  AppInventoryAdjustmentsIndexRoute: AppInventoryAdjustmentsIndexRoute,
  AppInventoryCountsIndexRoute: AppInventoryCountsIndexRoute,
  AppInventoryTransfersIndexRoute: AppInventoryTransfersIndexRoute,
  AppPaymentsCodIndexRoute: AppPaymentsCodIndexRoute,
  AppPurchasingOrdersIndexRoute: AppPurchasingOrdersIndexRoute,
  AppPurchasingReceiptsIndexRoute: AppPurchasingReceiptsIndexRoute,
  AppPurchasingReturnsIndexRoute: AppPurchasingReturnsIndexRoute,
  AppPurchasingSuppliersIndexRoute: AppPurchasingSuppliersIndexRoute,
  AppSettingsLocationsIndexRoute: AppSettingsLocationsIndexRoute,
  AppSettingsPagesIndexRoute: AppSettingsPagesIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

interface AuthRouteChildren {
  AuthForgotPasswordRoute: typeof AuthForgotPasswordRoute
  AuthResetPasswordRoute: typeof AuthResetPasswordRoute
  AuthSignUpRoute: typeof AuthSignUpRoute
  AuthSupportSignInRoute: typeof AuthSupportSignInRoute
  AuthSignInOtpRoute: typeof AuthSignInOtpRoute
  AuthSignInTotpRoute: typeof AuthSignInTotpRoute
  AuthSignInIndexRoute: typeof AuthSignInIndexRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthForgotPasswordRoute: AuthForgotPasswordRoute,
  AuthResetPasswordRoute: AuthResetPasswordRoute,
  AuthSignUpRoute: AuthSignUpRoute,
  AuthSupportSignInRoute: AuthSupportSignInRoute,
  AuthSignInOtpRoute: AuthSignInOtpRoute,
  AuthSignInTotpRoute: AuthSignInTotpRoute,
  AuthSignInIndexRoute: AuthSignInIndexRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  AuthRoute: AuthRouteWithChildren,
  SandboxEnterRoute: SandboxEnterRoute,
  CTokenRoute: CTokenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
